/* eslint-disable angular/on-watch */

/**
 * @ngdoc overview
 * @name trackingEvents
 * @description
 * Track application events on Google Analytics.
 *
 * @param {Object}  $rootScope       To subscribe to the route change events.
 * @param {Service} ccaSession       To get the selected customer.
 * @param {Service} tracking         To track events on Google Analytics.
 * @param {Object}  AUTH_EVENTS      The name of the events the method needs to listen for.
 * @param {Object}  TRACKING_EVENTS  The name of the events the method needs to listen for.
 * @memberof root
 */
const trackingEvents = (
  $rootScope,
  ccaSession,
  tracking,
  AUTH_EVENTS,
  TRACKING_EVENTS,
) => {
  'ngInject';

  const selectedAccount = ccaSession.getSelectedAccount();
  tracking.setCustomer(selectedAccount || {});

  const listeners = [];

  listeners.push($rootScope.$on(AUTH_EVENTS.customerChanged, (event, account) => {
    tracking.setCustomer(account.customer);
  }));

  // Navigation
  listeners.push(
    $rootScope.$on(
      TRACKING_EVENTS.navigation.clickLogin,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.navigation.clickHome,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.navigation.clickUpload,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.navigation.clickCommunity,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.navigation.clickMe,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.navigation.clickCampaign,
      (event) => tracking.trackEvent(event),
    ),
  );

  // Campaign
  listeners.push(
    $rootScope.$on(
      TRACKING_EVENTS.campaign.clickUpload,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.campaign.clickPhoto,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.campaign.clickGuidelines,
      (event) => tracking.trackEvent(event),
    ),
  );

  // Upload
  listeners.push(
    $rootScope.$on(
      TRACKING_EVENTS.upload.clickAddMore,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.upload.clickDelete,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.upload.clickCampaign,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.upload.clickFinish,
      (event) => tracking.trackEvent(event),
    ),
  );

  // Me
  listeners.push(
    $rootScope.$on(
      TRACKING_EVENTS.me.clickPhoto,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.me.clickLogout,
      (event) => tracking.trackEvent(event),
    ),
  );

  // Community
  listeners.push(
    $rootScope.$on(
      TRACKING_EVENTS.community.clickMostRecent,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.community.clickByCampaign,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.community.clickCampaignName,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.community.clickUpload,
      (event) => tracking.trackEvent(event),
    ),
    $rootScope.$on(
      TRACKING_EVENTS.community.clickPhoto,
      (event) => tracking.trackEvent(event),
    ),
  );

  // Photo
  listeners.push($rootScope.$on(
    TRACKING_EVENTS.photo.clickClose,
    (event) => tracking.trackEvent(event),
  ));

  $rootScope.$on('$destroy', () => {
    listeners.forEach((listener) => listener());
  });
};

export default trackingEvents;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/eventSubscribers/trackingEvents.js